/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const IncidentTypeDto = zod.object({
  "id": zod.number().optional(),
  "code": zod.string().optional(),
  "name": zod.string().optional()
});

export type IncidentTypeDto = zod.input<typeof IncidentTypeDto>;
export type IncidentTypeDtoOutput = zod.output<typeof IncidentTypeDto>;
